import { useNavigate, useParams } from 'react-router-dom';
import DataTableWrapper from '../../../Utility/DataTableWrapper/DataTableWrapper.js';
import { useContext, useEffect, useRef, useState } from 'react';
import { LibreriaService } from '../../../../services/LibreriaService.js';
import { BandoService } from '../../../../services/BandoService.js';
import Select from '../../../Form/Select.js';
import { FormUtility } from '../../../Utility/FormUtility.js';
import Modal from '../../../Utility/Modal/Modal.js';
import ToastContext from '../../../../contexts/toast.js';
import { rolesCodes } from '../../../../constants/Roles.js';
import { tipologieFase } from '../../../../constants/TipologiaFase';
import { ComuneService } from '../../../../services/ComuneService.js';
import { useSelector } from 'react-redux';
import Switch from '../../../Form/Switch.js';

export default function GestioneAnagraficaLibrerie() {
  console.log('inside gestione librerie');
  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const params = useParams();

  const [isModalOpen, setModalOpen] = useState(false);

  const [bandi, setBandi] = useState(null);
  const [bando, setBando] = useState(null);
  const [fase, setFase] = useState(null);
  const [libreria, setLibreria] = useState(null);
  const [comune, setComune] = useState(null);
  const [ente, setEnte] = useState(undefined);
  const [typeLibraries, setTypeLibraries] = useState('asso');

  const tipoLibrerie = [
    { key: 'asso', value: 'Librerie Associate' },
    { key: 'noAsso', value: 'Librerie non Associate' },
    { key: 'all', value: 'Tutte le Librerie' }
  ];

  const comuneService = new ComuneService();
  const bandoService = new BandoService();
  const libreriaService = new LibreriaService();

  const userRoles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: userRoles });

  const toastContext = useContext(ToastContext);

  const dtRef = useRef();

  useEffect(() => {
    bandoService.getAll().then((resp) => {
      setBandi(resp);
      const band = resp?.find(b => { return b.fasi.some(f => f.tipologia === tipologieFase.censimento_librerie && utility.checkFaseIsActive(f, 'dataInizio', 'dataFineCensimento', 'YYYY-MM-DD', 'YYYY-MM-DD')); });
      const bandum = band ?? resp?.[0] ?? bando;
      setBando(bandum);
      setFase(bandum ? bandum.fasi.find(f => f.tipologia === tipologieFase.censimento_librerie) : null);
    });

    comuneService.getById(params.id).then((resp) => {
      setComune(resp);
      setEnte(resp.ente);
    });
  }, []);

  useEffect(() => {
    console.log('cambiato dtoptions', dtOptions);
  }, [dtOptions]);

  const gotoGestioneLibreria = () => {
    navigate('/gestione-libreria/' + params.id);
  };

  const gotoModificaLibreria = (libreriaId) => {
    console.log(libreriaId);
    navigate('/gestione-libreria/' + params.id + '/' + libreriaId);
  };

  const handleModalAction = () => {
    libreriaService.delete(libreria.id).then(() => {
      dtRef.current.rerenderDatatable();
      setModalOpen(false);
      toastContext.success('Libreria eliminata con successo!', 6000);
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
		});
  };

  const eliminaLibreria = (libreria) => {
    if (libreria.richieste.length > 0) {
      return;
    }

    setLibreria(libreria);
    setModalOpen(true);

    console.log(libreria.id);
  };

  const validaSvalidaComune = (event, row) => {
    const value = event.target.checked;
    if (value) {
      libreriaService.valida(row.id, params.id).then(() => {
        dtRef.current.rerenderDatatable();
        toastContext.success('Libreria validata con successo!', 6000);
      }).catch(error => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
    } else {
      libreriaService.svalida(row.id, params.id).then(() => {
        dtRef.current.rerenderDatatable();
        toastContext.success('Libreria svalidata con successo!', 6000);
      }).catch(error => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
    }

    console.log(row.id);
  }

  const associaDisassociaLibreria = (event, row) => {
    const value = event.target.checked;
    if (value) {
      libreriaService.associate(row.id, params.id).then(() => {
        comuneService.getById(params.id).then((resp) => {
          setComune(resp);
          setEnte(resp.ente);
          dtRef.current.rerenderDatatable();
          toastContext.success('Libreria associata con successo!', 6000);
        });
      }).catch(error => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
    } else {
      libreriaService.remove(row.id, params.id).then(() => {
        comuneService.getById(params.id).then((resp) => {
          setComune(resp);
          setEnte(resp.ente);
          dtRef.current.rerenderDatatable();
          toastContext.success('Libreria disassociata con successo!', 6000);
        });
      }).catch(error => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
    }

    console.log(row.id);
  }

  const onChangeDataViewing = (event) => {
    setTypeLibraries(event.target.value);
  }

  useEffect(() => {
    if (!comune || !fase || ente === undefined) {
      return;
    }

    const dtOpt = {
      columns: [
        {
          name: 'Id',
          data: 'id',
          visible: true,
          sortable: true,
          searchable: false,
        },
        {
          name: 'Nome',
          data: 'nome',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Partita Iva',
          data: 'partitaIva',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Indirizzo',
          data: 'indirizzo',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Civico',
          data: 'civico',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'CAP',
          data: 'cap',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Comune',
          data: null,
          visible: true,
          sortable: false,
          searchable: true,
          cell: (row, col) => row.comune.denominazione
        },
        {
          name: 'Validato',
          data: null,
          visible: true,
          sortable: false,
          searchable: true,
          cell: (row, col) => {
            const isChecked = row.validato;
            return row.comune.id === parseInt(params.id)
              ? <label className='switch' htmlFor={`switch-validato-${row.id}`}>
                  <span className='rtds-sr-only'>
                    {isChecked ? 'Libreria associata' : 'Libreria non associata'}
                  </span>
                  <Switch
                    id={`switch-validato-${row.id}`}
                    tabIndex={0}
                    aria-checked={isChecked}
                    onChange={(event) => validaSvalidaComune(event, row)}
                    checked={isChecked}
                    disabled={
                      ente?.comuniAssociati.flatMap(ca => ca.librerieAssociate).length > 0 ||
                      comune.librerieAssociate.length > 0 ||
                      utility.checkRoles([rolesCodes.comune]) && !utility.checkFaseIsActive(fase, 'dataInizio', 'dataFineCensimento', 'YYYY-MM-DD', 'YYYY-MM-DD')
                    }
                  />
                </label>
              : null
          }
        },
        {
          name: 'Associa',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => {
            const isChecked = !!row.comuniAssociati.find(ca => ca.id === parseInt(params.id));
            return row.comune.id === parseInt(params.id)
                ? null
                : <label className='switch' htmlFor={`switch-${row.id}`}>
                    <span className='rtds-sr-only'>
                      {isChecked ? 'Libreria associata' : 'Libreria non associata'}
                    </span>
                    <Switch
                      id={`switch-${row.id}`}
                      tabIndex={0}
                      aria-checked={isChecked}
                      onChange={event => associaDisassociaLibreria(event, row)}
                      checked={isChecked}
                      disabled={
                        !isChecked &&
                        (
                          (ente?.comuniAssociati.flatMap(ca => ca.librerie).find(l => l.validato && !l.richiedeAssociazioneTesseramento) || ente?.comuniAssociati.flatMap(ca => ca.librerieAssociate).find(l => l.validato && !l.richiedeAssociazioneTesseramento)) ||
                          (comune.librerieAssociate.length >= 2) ||
                          (utility.checkRoles([rolesCodes.comune]) && !utility.checkFaseIsActive(fase, 'dataFineCensimento', 'dataFineSelezioneLibrerie', 'YYYY-MM-DD', 'YYYY-MM-DD'))
                        )
                      }
                    />
                  </label>
          }
        },
        {
          name: 'Azioni',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => 
            row.comune.id === parseInt(params.id)
              ? <div
                  className='rtds-inline-flex rtds-gap-1'
                  role='group'
                  aria-label='Azioni'
                >
                  <button
                    type='button'
                    className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                    onClick={() => gotoModificaLibreria(row.id)}
                  >
                    <svg
                      className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                      />
                    </svg>{' '}
                    Modifica
                  </button>{' '}
                  <button
                    type='button'
                    className='rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                    onClick={() => eliminaLibreria(row)}
                    disabled={row.richieste.length > 0}
                  >
                    <svg
                      className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                      />
                    </svg>{' '}
                    Elimina
                  </button>
                </div>
              : <button
                  type='button'
                  className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                  onClick={() => gotoModificaLibreria(row.id)}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                    />
                  </svg>{' '}
                  Visualizza
                </button>
        },
      ],
      serverSide: true,
      ajax: libreriaService.getAllDt,
      ajaxParams: { enteId: params.id, onlyAssociatedToEnte: typeLibraries === 'asso' ? true : typeLibraries === 'noAsso' ? false : null, bandoId: bando?.id },
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative libreria del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: 'Elenco Librerie',
      titleSecond: (
        <span className='rtds-content-02'>
          {comune.denominazione +
            (comune.codice
              ? ' (' + comune.denominazioneProvincia + ') Cod. ' + comune.codice
              : '')}
        </span>
      )
    };
    setDtOptions(dtOpt);
    loadData();
  }, [fase, comune, typeLibraries]);

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative libreria del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  const onChangeBando = (event) => {
    const bandoId = event.target.value;
    const band = bandoId ? bandi.find((b) => b.id === parseInt(bandoId)) : null;
    setBando(band);
    setFase(band ? band.fasi.find(f => f.tipologia === tipologieFase.censimento_librerie) : null);
  };

  return (
    <>
	    <div className='rtds-container rtds-my-12'>
        <Select
          classDiv={'rtds-mt-3 lg:rtds-mt-0'}
          label={'Avviso'}
          id={'bando_id'}
          classSelect={''}
          onChange={(event) => onChangeBando(event)}
          baseOption={'Seleziona Avviso'}
          bindKey={'id'}
          bindValue={'nome'}
          options={bandi}
          value={bando?.id || ''}
        />
	    </div>

      {
        bando &&
        <DataTableWrapper
          ref={dtRef}
          dtOptions={dtOptions}
          headerButton={
            <div className='rtds-flex rtds-gap-4 align-items rtds-flex-wrap'>
              {
                <Select
                  classDiv={'rtds-content-center'}
                  classLabel={'rtds-sr-only'}
                  label={'Filtra Operatori'}
                  id={'filtraOperatori'}
                  classSelect={'rtds-pr-7'}
                  onChange={(event) => onChangeDataViewing(event)}
                  bindKey={'key'}
                  bindValue={'value'}
                  options={tipoLibrerie}
                  value={typeLibraries || null}
                />
              }
              {
                bando &&
                utility.checkFaseIsActive(fase, 'dataInizio', 'dataFineCensimento', 'YYYY-MM-DD', 'YYYY-MM-DD')
                  ? <button
                      type='button'
                      className='rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button'
                      onClick={gotoGestioneLibreria}
                    >
                      <svg
                        className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                        aria-hidden='true'
                        focusable='false'
                        role='img'
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                        />
                      </svg>{' '}
                      Inserisci&nbsp;nuova&nbsp;Libreria
                    </button>
                  : null
              }
            </ div>
          }
        />
      }

      <Modal
        isOpen={isModalOpen}
        title='Eliminazione Libreria'
        content='Confermare eliminazione libreria selezionata?'
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel='Conferma'
        closeLabel='Annulla'
      />
    </>
  );
}
